module.exports = __webpack_public_path__ + "img/uid-game-guide-2.a7fd6bc1.png";